<template>
    <b-overlay :show="dataLoaded">
        <b-card>
            <b-button variant="primary" @click="addUser" v-if="$hasPermissions($permissions.EditAdminUsers)">Dodaj administratorja</b-button>
            <Table ref="table" class="mt-1" :fields="fields" route="/api/management/v1/admin">
                <template #cell(actions)="row" v-if="$hasPermissions($permissions.EditAdminUsers)">
                    <div class="d-flex justify-content-center">
                        <b-button class="mr-1" variant="warning" @click="editUser(row.item)"><fa icon="edit"/></b-button>
                        <b-button @click="deleteUser(row.item.id)" variant="danger"><fa icon="trash"/></b-button>
                    </div>
                </template>
            </Table>
        </b-card>
        <AdminUserModal ref="userModal" :type="type" :user="user" v-on:success="getItems()" :admin="true"/>
    </b-overlay>
</template>
<script>
    import AdminUserModal from '@/views/Admin/Users/AdminUserModal'
    import Table from '@/views/Components/Table'
    import {BButton, BCard, BOverlay} from 'bootstrap-vue'
    export default {
        components: {
            AdminUserModal,
            Table,
            BOverlay,
            BCard,
            BButton
        },
        data() {
            return {
                dataLoaded: false,
                user: {name: '', surname: '', email: '', password: '', administrator: true},
                type: '',
                fields: [
                    { key: 'name', label: 'Ime', sortable: true, class: 'text-center' },
                    { key: 'surname', label: 'Priimek', sortable: true, class: 'text-center' },
                    { key: 'email', label: 'Email', sortable: true, class: 'text-center' }
                ]
            }
        },
        methods: {
            getItems() {
                setTimeout(function() {
                    this.$refs.table.search()
                }.bind(this), 1000)
            },
            addUser() {
                this.type = 'add'
                this.user = {name: '', surname: '', email: '', telephone_number: '', password: '', administrator: true}
                this.$refs.userModal.openModal()
            },
            editUser(user) {
                this.type = 'edit'
                this.user = user
                this.$refs.userModal.openModal()
            },
            deleteUser(id) {
                this.$bvModal.msgBoxConfirm('Prosimo potrdite, da želite izbrisati administratorja.', {
                    size: 'sm',
                    okTitle: 'Da',
                    cancelTitle: 'Ne',
                    hideHeaderClose: false,
                    okVariant: 'danger',
                    cancelVariant: 'outline-secondary',
                    centered: true
                }).then(value => {
                    if (value) {
                        const thisIns = this
                        const loadPromise = this.$http.delete(`/api/management/v1/admin/${id}`)
                        loadPromise.then(function() {
                            thisIns.$printSuccess('Uporabnik je izbrisan')
                        }).catch(function(error) {
                            thisIns.$printError(error.response.data)
                        }).finally(function() {
                            thisIns.$refs.table.search()
                        })
                    }
                })
            }
        },
        mounted() {
            if (this.$hasPermissions(this.$permissions.EditAdminUsers)) {
                this.fields.push({ key: 'actions', label: '', class: 'text-center' })
            }
        }
    }
</script>
